import { isValidAddress } from 'algosdk'

export default isValidAddress
